export const mapSignInPostRequestValues = credentials => ({
    email: credentials.email,
    password: credentials.password,
});

export const mapSignUpPostRequestValues = credentials => {
    const requestObj = {
        avatar: credentials.avatar,
        fullname: credentials.fullName,
        email: credentials.email,
        password: credentials.password,
        confirmation: credentials.passwordConfirmation,
        mobile: credentials.phoneNumber,
        platform: credentials.platform,
    };

    if (credentials.invitationCode) requestObj.invitation_code = credentials.invitationCode;
    return requestObj;
};

export const mapResetPasswordEmailPostRequestValues = fields => ({
    email: fields.email,
});

export const mapUpdatePasswordPostRequestValues = fields => ({
    password: fields.password,
});



// WEBPACK FOOTER //
// ./src/BusinessLogic/Handlers/Authentication/index.js